import styled from "@emotion/styled";
import { fonts } from "styles/fonts";
import { colors } from "styles/colors";
import { ButtonWrap } from "shared/Button/styled";

export const Wraper = styled.div``;

export const PreviewButtons = styled.div`
  ${Wraper} {
    button {
      margin-top: 12px;
      text-align: center;
    }
    button:disabled {
      text-align: left;
      margin-top: 21px;
      icon {
        margin-right: 11px;
      }
    }
  }
  @media (min-width: 769px) {
    margin-top: auto;
    ${Wraper} {
      button {
        margin-top: 15px;
      }
    }
  }
  @media (max-width: 768px) {
    ${Wraper} {
      &:first-of-type {
        button {
          letter-spacing: 1px;
        }
      }
    }
  }
`;
/* Style Tag */
export const Tag = styled.span`
  position: relative;
  margin-right: 4px;
  display: inline-block;
  text-transform: lowercase;
  &:before {
    content: "";
    display: inline-block;
    bottom: 3px;
    left: 0;
    right: 5px;
    position: absolute;
    height: 1px;
    background-color: #222424;
    -webkit-transition: opacity 0.3s ease 0s;
    transition: opacity 0.3s ease 0s;
  }
  &:after {
    content: ",";
    margin-left: 1px;
    display: inline-block;
    bottom: 0;
    right: 0;
    position: relative;
    color: ${colors.GREY};
  }
  &:last-of-type {
    margin-right: 0;
    &:before {
      right: 2px;
    }
    &:after {
      content: "";
    }
  }
`;

/* Style TagsWrap */
export const TagsWrap = styled.div`
  margin-bottom: 16px;
`;

/* Style PreviewDesc */
export const PreviewDesc = styled.div`
  font-family: ${fonts.latoMedium};
  color: ${colors.GREY_SEMIDARK};
  line-height: 1.2;
  @media (min-width: 769px) {
    line-height: 1.4;
    letter-spacing: -0.1px;
  }
`;

export const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    width: 4em;
    height: 4em;
  }
`;

/* Style PreviewImg */
export const PreviewImg = styled.div`
  position: relative;
  height: 328px;
  margin-bottom: 20px;
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${colors.GREY_LIGHT};
  img {
    border-radius: 20px;
    display: block;
    height: 100%;
    width: 100%;
    max-width: none;
    object-fit: cover;
    object-position: center center;
    text-align: center;
  }
  @media (min-width: 769px) {
    margin-bottom: 0;
    height: 280px;
    max-width: 280px;
    flex: 0 0 400px;
    margin-right: 20px;
  }
  @media (min-width: 1024px) {
    margin-right: 30px;
    height: 400px;
    max-width: 400px;
  }
`;

/* Style PreviewInfo */
export const PreviewInfo = styled.div``;

/* Style PreviewContent */
export const PreviewContent = styled.div`
  margin-top: 19px;
  @media (min-width: 769px) {
    padding-bottom: 24px;
  }
  flex: 1;
  display: flex;
  flex-direction: column;
`;

/* Style PreviewBarWrap */
export const PreviewBarWrap = styled.div`
  color: ${colors.GREY_SEMIDARK};
  line-height: inherit;
  span {
    color: ${colors.GREY_DARK};
  }
  @media (max-width: 768px) {
    border-bottom: 1px solid #f2f5f5;
    line-height: 1.75;
    margin-bottom: 17px;
  }
`;

export const PreviewBarWrapRecipe = styled.div`
  color: ${colors.GREY_SEMIDARK};
  line-height: inherit;
  span {
    color: ${colors.GREY_DARK};
  }
  @media (max-width: 768px) {
    line-height: 1.75;
    margin-bottom: 17px;
  }
`;

/* Style PreviewWrap */
export const PreviewWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 30px 0 30px;

  ${PreviewDesc} {
    p {
      margin: 0;
      + p {
        margin-top: 8px;
      }
    }
  }
  ${ButtonWrap} {
    width: 100%;
    text-align: left;
  }
  @media (min-width: 769px) {
    flex-direction: row;
    margin: 30px 0 0;
    padding-bottom: 31px;
    ${ButtonWrap} {
      width: auto;
    }
  }
  @media (min-width: 769px) {
    padding: 0 0 30px;
    border-bottom: 1px solid ${colors.GREY_LIGHT};
  }
`;
export const NoImage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  height: 100%;
  width: 100%;
  max-width: none;
  object-fit: cover;
  object-position: center center;
  background-color: ${colors.GREY_LIGHT};
  color: #222424;
  font-family: ${fonts.latoBold};
  font-size: 24px;
  border-radius: 20px;
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    height: 127px;
    width: 127px;
    display: block;
    background: url("/images/noimage.png") no-repeat 0 0;
    background-size: cover;
  }
`;
